module.exports = __webpack_public_path__ + "static/media/exercises-step5.6a4fbb6c.png";